export const initialvalues = {
    firstname: "",
    lastname: "",
    email: "",
    mobilePhone: "",
    address: "",
  };

  export const TABLE_HEAD = [
    "Customer Name",
    "Email",
    "Mobile Phone",
    "Adress",
    // "Event count",
    "Edit",
    "Delete" 
];